import {
  InvoiceStatus,
  InvoiceStatusConfig,
  InvoiceStatusesConfig,
} from "@portal/types/entities/invoice";

export const invoiceStatusConfig: InvoiceStatusConfig = {
  PENDING: {
    label: "Pending",
    style: {
      borderColor: "var(--orange-1)",
      backgroundColor: "var(--orange-1)",
      textColor: "var(--orange-6)",
    },
  },
  REOPEN: {
    label: "Reopen",
    style: {
      borderColor: "var(--yellow-1)",
      backgroundColor: "var(--yellow-1)",
      textColor: "var(--yellow-6)",
    },
  },
  DISPUTE: {
    label: "Dispute",
    style: {
      borderColor: "var(--orange-1)",
      backgroundColor: "var(--orange-1)",
      textColor: "var(--orange-6)",
    },
  },
  PARTIAL_PAYMENT: {
    label: "Partly Paid",
    style: {
      borderColor: "var(--green-1)",
      backgroundColor: "var(--green-1)",
      textColor: "var(--green-6)",
    },
  },
  FULL_PAYMENT: {
    label: "Full Payment",
    style: {
      borderColor: "var(--green-1)",
      backgroundColor: "var(--green-1)",
      textColor: "var(--green-6)",
    },
  },
  WRITE_OFF: {
    label: "Write Off",
    style: {
      borderColor: "var(--red-1)",
      backgroundColor: "var(--red-1)",
      textColor: "var(--red-6)",
    },
  },
  CLOSED: {
    label: "Closed",
    style: {
      borderColor: "var(--red-1)",
      backgroundColor: "var(--red-1)",
      textColor: "var(--red-6)",
    },
  },
  DRAFT: {
    label: "Draft",
    style: {
      borderColor: "var(--green-1)",
      backgroundColor: "var(--green-1)",
      textColor: "var(--green-6)",
    },
  },
  VOID: {
    label: "Void",
    style: {
      borderColor: "var(--volcano-1)",
      backgroundColor: "var(--volcano-1)",
      textColor: "var(--volcano-6)",
    },
  },
};
export const invoiceStatusesConfig: InvoiceStatusesConfig = {
  CLOSED: ["WRITE_OFF", "CLOSED", "VOID"],
  ALL: [
    "PENDING",
    "REOPEN",
    "DISPUTE",
    "PARTIAL_PAYMENT",
    "FULL_PAYMENT",
    "WRITE_OFF",
    "CLOSED",
    "VOID",
  ],
  OPEN: ["PENDING", "DISPUTE", "PARTIAL_PAYMENT", "FULL_PAYMENT"],
  DRAFT: ["DRAFT"],
};

export function getInvoiceStatusConfig(status: InvoiceStatus) {
  return invoiceStatusConfig[status];
}
